(() => {
  const url = new URL(window.location.href);
  const claim = url.searchParams.get('mv_reward_claim');
  const variant = url.searchParams.get('mv_reward_variant');
  const title = url.searchParams.get('mv_reward_title') || 'Nagroda Mini Verse';
  if (!claim || !/^\d+$/.test(variant || '') || !/^[a-z0-9-]+$/i.test(claim)) return;

  const cleanUrl = new URL('/cart', window.location.origin);
  window.history.replaceState({}, '', cleanUrl);
  fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
    method: 'POST',
    headers: {'Content-Type': 'application/json', Accept: 'application/json'},
    body: JSON.stringify({
      items: [{
        id: Number(variant),
        quantity: 1,
        properties: {
          '_mini_verse_reward_claim': claim,
          'Nagroda Mini Verse': title,
        },
      }],
    }),
  })
    .then((response) => {
      if (!response.ok) throw new Error('Cart add failed');
      window.location.replace('/cart');
    })
    .catch(() => {
      window.alert('Nie udało się dodać nagrody. Wróć do Moje Mini Verse i spróbuj ponownie.');
    });
})();
